import { getGemTypeByProcess } from '@common/getGemTypeByProcess';
import { GenericGraphProcessType, CommonGraph } from '@common/types';

import { WorkflowMode } from '../../../graphqlTypes/enums';
import { getGraphProcess } from '../../../Parser/bindings';
import { ProcessKind } from '../../graph/types';

export function getGemType<G extends CommonGraph>(graph: G, graphPath: string, componentId: string, rootPath: string) {
  const process = getGraphProcess(graph, graphPath, componentId, rootPath);
  return process ? getGemTypeByProcess(process) : undefined;
}
export function getGemTypeLabelBySpec<S extends { label?: string; kind: string }>(spec: S) {
  return spec.label ?? spec.kind;
}
function isSteamingProcess<G extends CommonGraph>(process: GenericGraphProcessType<G>) {
  return ([ProcessKind.StreamingSource, ProcessKind.StreamingTarget] as string[]).includes(process.component);
}

export function getGemMode<G extends CommonGraph>(process: GenericGraphProcessType<G>) {
  return isSteamingProcess(process) ? WorkflowMode.stream : WorkflowMode.batch;
}
export function isIOComponent(component: ProcessKind) {
  return [ProcessKind.Source, ProcessKind.Target, ProcessKind.StreamingSource, ProcessKind.StreamingTarget].includes(
    component
  );
}
export function isStreamingIOComponent(component: ProcessKind) {
  return [ProcessKind.StreamingSource, ProcessKind.StreamingTarget].includes(component);
}
